import { PageHero } from "@/components/site/PageHero";
import { ServicesBento } from "@/components/site/ServicesBento";
import { Notice112 } from "@/components/site/Notice112";
import { CtaBand } from "@/components/site/CtaBand";
import { Reveal } from "@/components/site/motion";
import { ConsulenzaTerzoSettore } from "@/components/site/ConsulenzaTerzoSettore";

export default function Servizi() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Servizi"
        lines={["Servizi sanitari", "organizzati con cura."]}
        intro="Sei aree di servizio coordinate dalla Centrale Operativa Nexus e svolte da una rete qualificata di partner. Scegli l'ambito che ti interessa per conoscere i dettagli."
      />
      <section className="bg-mist pb-20 md:pb-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <ServicesBento />
          <Reveal className="mt-14"><Notice112 /></Reveal>
        </div>
      </section>
      <ConsulenzaTerzoSettore />
      <CtaBand />
    </div>
  );
}
